import { render } from "./GalleryList.vue?vue&type=template&id=119a6904&scoped=true"
import script from "./GalleryList.vue?vue&type=script&lang=js"
export * from "./GalleryList.vue?vue&type=script&lang=js"

import "./GalleryList.vue?vue&type=style&index=0&id=119a6904&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-119a6904"]])

export default __exports__